/**
 * @file themeUtils.ts
 * @description Theme management utility supporting Dark (Obsidian), Light (White), and System theme modes.
 */

export type ThemeMode = 'dark' | 'light' | 'system';

export const getStoredTheme = (): ThemeMode => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get('theme');
    if (themeParam === 'light' || themeParam === 'dark' || themeParam === 'system') {
      localStorage.setItem('appTheme', themeParam);
      return themeParam;
    }
  } catch {
    // Ignore URL parsing errors if any
  }
  return (localStorage.getItem('appTheme') as ThemeMode) || 'dark';
};

export const applyTheme = (theme: ThemeMode): void => {
  localStorage.setItem('appTheme', theme);
  let effectiveTheme = theme;
  if (theme === 'system') {
    effectiveTheme = window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  }
  document.documentElement.setAttribute('data-theme', effectiveTheme);
};

// Apply saved theme immediately
applyTheme(getStoredTheme());
